{
    "Timezone_Default": "Défaut",
    "Timezone_International_Date_Line_West": "(GMT-12:00) Ligne de changement de date internationale ouest",
    "Timezone_Midway": "(GMT-11:00) Île Midway",
    "Timezone_Hawaii": "(GMT-10:00) Hawaï",
    "Timezone_Alaska_DLS": "(GMT-09:00) Alaska [DLS]",
    "Timezone_Pacific_Time_US_Canada_DLS": "(GMT-08:00) Heure du Pacifique (États-Unis \/ Canada) [DLS]",
    "Timezone_Tijuana_Baja_California_DLS": "(GMT-08:00) Tijuana, Basse-Californie [DLS]",
    "Timezone_Arizona": "(GMT-07:00) Arizona",
    "Timezone_Chihuahua_La_Paz_Mazatlan": "(GMT-07:00) Chihuahua, La Paz, Mazatlán",
    "Timezone_Mountain_Time_US_Canada_DLS": "(GMT-07:00) Heure des Rocheuses (États-Unis \/ Canada) [DLS]",
    "Timezone_Central_America": "(GMT-06:00) Amérique centrale",
    "Timezone_Central_Time_US_Canada_DLS": "(GMT-06:00) Heure du Centre (États-Unis \/ Canada) [DLS]",
    "Timezone_Guadalajara_Mexico_City_Monterrey": "(GMT-06:00) Guadalajara, Mexico, Monterrey",
    "Timezone_Saskatchewan": "(GMT-06:00) Saskatchewan",
    "Timezone_Bogota_Lima_Quito_Rio_Branco": "(GMT-05:00) Bogota, Lima, Quito, Rio Branco",
    "Timezone_Eastern_Time_US_Canada_DLS": "(GMT-05:00) Heure de l'Est (États-Unis \/ Canada) [DLS]",
    "Timezone_Indiana_East_DLS": "(GMT-05:00) Indiana (Est) [DLS]",
    "Timezone_Caracas": "(GMT-04:00) Caracas",
    "Timezone_Atlantic_Time_Canada_DLS": "(GMT-04:00) Heure de l'Atlantique (Canada) [DLS]",
    "Timezone_La_Paz": "(GMT-04:00) La Paz",
    "Timezone_Manaus": "(GMT-04:00) Manaus",
    "Timezone_Georgetown": "(GMT-04:00) Georgetown",
    "Timezone_Santiago_DLS": "(GMT-04:00) Santiago [DLS]",
    "Timezone_Newfoundland_DLS": "(GMT-03:30) Terre-Neuve [DLS]",
    "Timezone_Brasilia": "(GMT-03:00) Brasilia",
    "Timezone_Buenos_Aires": "(GMT-03:00) Buenos Aires",
    "Timezone_Montevideo": "(GMT-03:00) Montevideo",
    "Timezone_Greenland_Godthab_DLS": "(GMT-02:00) Groenland (Godthab, Nuuk) [DLS]",
    "Timezone_Mid_Atlantic": "(GMT-02:00) Mid-Atlantique",
    "Timezone_Azores_DLS": "(GMT-01:00) Açores [DLS]",
    "Timezone_Cape_Verde_Islands": "(GMT-01:00) Îles du Cap-Vert",
    "Timezone_Dublin_Edinburgh_Lisbon_London_DLS": "(GMT+00:00) Dublin, Édimbourg, Lisbonne, Londres [DLS]",
    "Timezone_Greenwich_Mean_Time": "(GMT+00:00) Heure moyenne de Greenwich",
    "Timezone_Monrovia_Reykjavik": "(GMT+00:00) Monrovia, Reykjavik",
    "Timezone_Amsterdam_Berlin_Rome_Bern_Vienna_DLS": "(GMT+01:00) Amsterdam, Berlin, Rome, Berne, Vienne [DLS]",
    "Timezone_Belgrade_Bratislava_Budapest_Prague_DLS": "(GMT+01:00) Belgrade, Bratislava, Budapest, Prague [DLS]",
    "Timezone_Brussels_Copenhagen_Madrid_Paris_DLS": "(GMT+01:00) Bruxelles, Copenhague, Madrid, Paris [DLS]",
    "Timezone_Sarajevo_Skopje_Warsaw_Zagreb_DLS": "(GMT+01:00) Sarajevo, Skopje, Varsovie, Zagreb [DLS]",
    "Timezone_Casablanca_DST": "(GMT+01:00) Casablanca [DLS]",
    "Timezone_West_Central_Africa": "(GMT+01:00) Afrique centrale occidentale",
    "Timezone_Windhoek": "(GMT+02:00) Windhoek",
    "Timezone_Athens_Bucharest": "(GMT+02:00) Athènes ; Bucarest",
    "Timezone_Beirut_DLS": "(GMT+02:00) Beyrouth [DLS]",
    "Timezone_Cairo_DLS": "(GMT+02:00) Le Caire [DLS]",
    "Timezone_Harare_Pretoria": "(GMT+02:00) Harare, Pretoria",
    "Timezone_Helsinki_Kyiv_Riga_Sofia_Tallinn_Vilnius_DLS": "(GMT+02:00) Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius [DLS]",
    "Timezone_Jerusalem_DLS": "(GMT+02:00) Jérusalem [DLS]",
    "Timezone_Baghdad_DLS": "(GMT+03:00) Bagdad [DLS]",
    "Timezone_Amman": "(GMT+03:00) Amman; Istanbul",
    "Timezone_Kuwait_Riyadh": "(GMT+03:00) Koweït, Riyad",
    "Timezone_Moscow_St_Petersburg_Volgograd": "(GMT+03:00) Moscou, Saint-Pétersbourg, Volgograd",
    "Timezone_Minsk": "(GMT+03:00) Minsk",
    "Timezone_Nairobi": "(GMT+03:00) Nairobi",
    "Timezone_Tehran": "(GMT+03:30) Téhéran",
    "Timezone_Tbilisi": "(GMT+04:00) Tbilissi",
    "Timezone_Abu_Dhabi_Muscat": "(GMT+04:00) Abou Dhabi, Mascate",
    "Timezone_Baku": "(GMT+04:00) Bakou",
    "Timezone_Mauritius": "(GMT+04:00) Maurice, Port Louis",
    "Timezone_Yerevan_DLS": "(GMT+04:00) Erevan [DLS]",
    "Timezone_Kabul": "(GMT+04:30) Kaboul",
    "Timezone_Yekaterinburg": "(GMT+05:00) Ekaterinbourg",
    "Timezone_Islamabad_Karachi": "(GMT+05:00)Islamabad, Karachi",
    "Timezone_Tashkent": "(GMT+05:00) Tachkent, Astana, Almaty",
    "Timezone_Chennai_Kolkata_Mumbai_New_Delhi": "(GMT+05:30) Chennai, Calcutta, Mumbai, New Delhi",
    "Timezone_Sri_Jayawardenepura": "(GMT+05:30) Colombo, Sri Jayawardenepura",
    "Timezone_Katmandu": "(GMT+05:45) Katmandou",
    "Timezone_Dhaka": "(GMT+06:00) Dhaka",
    "Timezone_Yangon_Rangoon": "(GMT+06:30) Yangon (Rangoon)",
    "Timezone_Bangkok_Jakarta": "(GMT+07:00) Bangkok, Jakarta",
    "Timezone_Krasnoyarsk": "(GMT+07:00) Krasnoïarsk",
    "Timezone_Novosibirsk": "(GMT+07:00) Novossibirsk",
    "Timezone_Hong_Kong": "(GMT+08:00) Pékin, Chongqing, Hong Kong, Urumqi",
    "Timezone_Irkutsk": "(GMT+08:00) Irkoutsk, Oulan-Bator",
    "Timezone_Kuala_Lumpur": "(GMT+08:00) Kuala Lumpur, Singapour",
    "Timezone_Perth": "(GMT+08:00) Perth",
    "Timezone_Taipei": "(GMT+08:00) Taipei",
    "Timezone_Tokyo": "(GMT+09:00) Osaka, Sapporo, Tokyo",
    "Timezone_Seoul": "(GMT+09:00) Séoul",
    "Timezone_Yakutsk": "(GMT+09:00) Iakoutsk",
    "Timezone_Adelaide": "(GMT+09:30) Adélaïde [DLS]",
    "Timezone_Darwin": "(GMT+09:30) Darwin",
    "Timezone_Brisbane": "(GMT+10:00) Brisbane",
    "Timezone_Canberra_Melbourne_Sydney": "(GMT+10:00) Canberra, Melbourne, Sydney [DLS]",
    "Timezone_Port_Moresby": "(GMT+10:00) Guam, Port Moresby",
    "Timezone_Hobart": "(GMT+10:00) Hobart [DLS]",
    "Timezone_Vladivostok": "(GMT+10:00) Vladivostok",
    "Timezone_Magadan": "(GMT+11:00) Magadan, Îles Salomon, Nouvelle-Calédonie",
    "Timezone_Auckland_Wellington": "(GMT+12:00) Auckland, Wellington [DLS]",
    "Timezone_Fiji": "(GMT+12:00) Fidji, Kamchatka, Îles Marshall",
    "Timezone_Tongatapu": "(GMT+13:00) Tongatapu",
    "Timezone_Samoa": "(GMT+13:00) Samoa",
    "Timezone_Kiritimati": "(GMT+14:00) Kiritimati, Île Christmas",
    "NAME": "Timezone"
}